import { render } from "./ssdetail.vue?vue&type=template&id=faedb14e&scoped=true"
import script from "./ssdetail.vue?vue&type=script&lang=js"
export * from "./ssdetail.vue?vue&type=script&lang=js"

import "./ssdetail.vue?vue&type=style&index=0&id=faedb14e&lang=scss&scoped=true"
import "./ssdetail.vue?vue&type=style&index=1&id=faedb14e&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faedb14e"]])

export default __exports__